import Navigator from '../../../components/common/Navigator'
import ProfileCreate from './Create'
import React from 'react'
import { Button } from '../../../components/common'

export default function ProfileForm() {
  const [isEditing, setIsEditing] = React.useState(false)
  return (
    <div className="lg:py-2 p-2 lg:w-11/12 lg:mx-auto">
      <div className="pb-4 flex items-center justify-between">
        <Navigator title="Profile Details" slug="PROFILE_DETAILS" />
        <div className="flex items-center gap-2">
          {!isEditing && (
            <Button
              type="button"
              className="inline-flex items-center gap-1.5 px-5 py-2 text-white rounded-xl text-sm font-bold bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 shadow-[0_4px_14px_rgba(249,115,22,0.3)] hover:shadow-[0_6px_18px_rgba(249,115,22,0.4)] hover:scale-[1.03] active:scale-[0.97] transition-all duration-300"
              onClick={() => setIsEditing(true)}
              label="✏️ Edit Profile"
            />
          )}
          {isEditing && (
            <Button
              type="button"
              className="inline-flex items-center gap-1.5 px-5 py-2 text-white rounded-xl text-sm font-bold bg-gradient-to-r from-slate-500 to-slate-600 hover:from-slate-600 hover:to-slate-700 shadow-[0_4px_14px_rgba(100,116,139,0.3)] hover:scale-[1.03] active:scale-[0.97] transition-all duration-300"
              onClick={() => setIsEditing(false)}
              label="✕ Cancel"
            />
          )}
        </div>
      </div>
      <ProfileCreate
        key={isEditing ? 'edit' : 'view'}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
    </div>
  )
}
